export default __webpack_public_path__ + "static/media/item5.05fc11c6.jpeg";